import { render, staticRenderFns } from "./StudioMyGames.vue?vue&type=template&id=f9d99674"
import script from "./StudioMyGames.vue?vue&type=script&lang=js"
export * from "./StudioMyGames.vue?vue&type=script&lang=js"
import style0 from "./StudioMyGames.vue?vue&type=style&index=0&id=f9d99674&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports